export default "__VITE_ASSET__779e6e58__"